<template>
    <div class="w9-contract-template">
        <vue-html2pdf :show-layout="true" :float-layout="false" :enable-download="false" :preview-modal="false"
            filename="test.pdf" :pdf-quality="2" :manual-pagination="true" pdf-format="a4" pdf-orientation="portrait"
            pdf-content-width="190mm" :htmlToPdfOptions="htmlToPdfOptions" @beforeDownload="beforeDownload($event)"
            @hasDownloaded="hasDownloaded($event)" ref="html2Pdf">
            <section slot="pdf-content">
                <!-- Page 1: W-9 Form -->
                <div class="page-content page-section">
                    <!-- Header Section -->
                    <header class="form-header">
                        <div class="header-left">
                            <div class="form-info">
                                <p>Form <strong class="form-w9">W-9</strong></p>
                                <p>(Rev. December 2014)</p>
                                <p>Department of the Treasury</p>
                                <p>Internal Revenue Service</p>
                            </div>
                        </div>

                        <div class="header-center">
                            <h1 class="main-title">Request for Taxpayer<br>Identification Number and Certification</h1>
                        </div>

                        <div class="header-right">
                            <div class="give-form-text">
                                <strong>Give Form to the<br>requester. Do not<br>send to the IRS.</strong>
                            </div>
                        </div>
                    </header>

                    <!-- Main Form Section -->
                    <div class="form-body">
                        <div class="print-instruction-left">
                            <div class="print-instruction">
                                <p><strong>Print or type.</strong><br>See <strong>Specific Instructions</strong> on page
                                    3.
                                </p>
                            </div>
                        </div>

                        <div style="padding: 10px; width: 100%;">
                            <!-- Line 1: Name -->
                            <div class="form-line">
                                <div class="line-number"><strong>1</strong></div>
                                <div class="line-content">
                                    <label class="line-label">Name (as shown on your income tax return). Name is
                                        required on
                                        this line; do not leave this line blank.</label>
                                    <div class="input-field">
                                        <span class="form-data">{{ name || '' }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Line 2: Business Name -->
                            <div class="form-line">
                                <div class="line-number"><strong>2</strong></div>
                                <div class="line-content">
                                    <label class="line-label">Business name/disregarded entity name, if different from
                                        above</label>
                                    <div class="input-field">
                                        <span class="form-data">{{ business_name || '' }}</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Line 3: Federal Tax Classification -->
                            <div class="form-line tax-classification">
                                <div class="line-number"><strong>3</strong></div>
                                <div class="line-content">
                                    <label class="line-label">Check appropriate box for federal tax classification of
                                        the
                                        person whose name is entered on line 1. Check only <strong>one</strong> of the
                                        following seven boxes.</label>

                                    <div class="tax-options">
                                        <div class="tax-options-left">
                                            <div class="checkbox-item">
                                                <input type="radio" v-model="federal_tax" value="individual"
                                                    name="fed_tax_classification" class="radio-input">
                                                <label>Individual/sole proprietor
                                                    or<br>&nbsp;&nbsp;&nbsp;&nbsp;single-member LLC</label>
                                            </div>

                                            <div class="checkbox-item">
                                                <input type="radio" v-model="federal_tax" value="c_corporation"
                                                    name="fed_tax_classification" class="radio-input">
                                                <label>C Corporation</label>
                                            </div>

                                            <div class="checkbox-item">
                                                <input type="radio" v-model="federal_tax" value="s_corporation"
                                                    name="fed_tax_classification" class="radio-input">
                                                <label>S Corporation</label>
                                            </div>

                                            <div class="checkbox-item">
                                                <input type="radio" v-model="federal_tax" value="partnership"
                                                    name="fed_tax_classification" class="radio-input">
                                                <label>Partnership</label>
                                            </div>

                                            <div class="checkbox-item">
                                                <input type="radio" v-model="federal_tax" value="trust"
                                                    name="fed_tax_classification" class="radio-input">
                                                <label>Trust/estate</label>
                                            </div>
                                        </div>

                                        <div class="tax-options-right">
                                            <div class="exemptions-box">
                                                <div class="exemption-title">
                                                    <strong>4</strong> Exemptions (codes apply only to<br>
                                                    certain entities, not individuals; see<br>
                                                    instructions on page 3):
                                                </div>

                                                <div class="exemption-row">
                                                    <label>Exempt payee code (if any)</label>
                                                    <div class="exemption-input">{{ exempt_payee_code || '' }}</div>
                                                </div>

                                                <div class="exemption-row">
                                                    <label>Exemption from FATCA reporting<br>code (if any)</label>
                                                    <div class="exemption-input">{{ exempt_fatca_reporting || '' }}
                                                    </div>
                                                </div>

                                                <div class="small-note">(Applies to accounts maintained outside the
                                                    U.S.)
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="llc-section">
                                        <div class="checkbox-item">
                                            <input type="radio" v-model="federal_tax" value="limited_liability"
                                                name="federal_tax_classification" class="radio-input">
                                            <label>Limited liability company. Enter the tax classification (C=C
                                                corporation,
                                                S=S corporation, P=Partnership) ►</label>
                                            <div class="tax-class-input">{{ tax_classification || '' }}</div>
                                        </div>

                                        <div class="llc-note">
                                            <strong>Note:</strong> Check the appropriate box in the line above for the
                                            tax
                                            classification of the single-member owner. Do not check<br>
                                            LLC if the LLC is classified as a single-member LLC that is disregarded from
                                            the
                                            owner unless the owner of the LLC is<br>
                                            another LLC that is not disregarded from the owner for U.S. federal tax
                                            purposes. Otherwise, a single-member LLC that is<br>
                                            disregarded from the owner should check the appropriate box for the tax
                                            classification of its owner.
                                        </div>

                                        <div class="checkbox-item other-item">
                                            <input type="radio" v-model="federal_tax" value="other"
                                                name="federal_tax_classification" class="radio-input">
                                            <label>Other (see instructions) ►</label>
                                            <div class="other-input">{{ other_classification || '' }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Lines 5-6-7: Address Section -->
                            <div class="address-section">
                                <div class="address-left">
                                    <!-- Line 5: Address -->
                                    <div class="form-line">
                                        <div class="line-number"><strong>5</strong></div>
                                        <div class="line-content">
                                            <label class="line-label">Address (number, street, and apt. or suite no.)
                                                See
                                                instructions.</label>
                                            <div class="input-field">
                                                <span class="form-data">{{ street_address1 || '' }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Line 6: City, State, ZIP -->
                                    <div class="form-line">
                                        <div class="line-number"><strong>6</strong></div>
                                        <div class="line-content">
                                            <label class="line-label">City, state, and ZIP code</label>
                                            <div class="input-field">
                                                <span class="form-data">{{ fullAddress || '' }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Line 7: Account Numbers -->
                                    <div class="form-line">
                                        <div class="line-number"><strong>7</strong></div>
                                        <div class="line-content">
                                            <label class="line-label">List account number(s) here (optional)</label>
                                            <div class="input-field">
                                                <span class="form-data">{{ list_account_numbers || '' }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="requester-section">
                                    <div class="requester-label">Requester's name and address (optional)</div>
                                    <div class="requester-box">
                                        <span class="form-data">{{ requester_name_address || '' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Part I: TIN Section -->
                    <div class="part-section">
                        <div class="part-header">
                            <h2><span class="part-number">Part I</span> Taxpayer Identification Number (TIN)</h2>
                        </div>

                        <div class="tin-content">
                            <div class="tin-instructions">
                                <p>Enter your TIN in the appropriate box. The TIN provided must match the name given on
                                    line 1 to avoid backup withholding. For individuals, this is generally your social
                                    security number (SSN). However, for a resident alien, sole proprietor, or
                                    disregarded entity, see the instructions for Part I, later. For other entities, it
                                    is your employer identification number (EIN). If you do not have a number, see How
                                    to get a TIN, later.</p>
                                <p><strong>Note:</strong> If the account is in more than one name, see the instructions
                                    for line 1. Also see What Name and Number To Give the Requester for guidelines on
                                    whose number to enter.</p>
                            </div>

                            <div class="tin-inputs">
                                <div class="tin-field">
                                    <label><strong>Social security number</strong></label>
                                    <div class="ssn-boxes">
                                        <span class="ssn-group">{{ social_security ? social_security.substring(0, 3) :
                                            '___' }}</span>
                                        <span class="separator">-</span>
                                        <span class="ssn-group">{{ social_security ? social_security.substring(3, 5) :
                                            '__' }}</span>
                                        <span class="separator">-</span>
                                        <span class="ssn-group">{{ social_security ? social_security.substring(5, 9) :
                                            '____' }}</span>
                                    </div>
                                </div>

                                <div class="or-divider"><strong>or</strong></div>

                                <div class="tin-field">
                                    <label><strong>Employer identification number</strong></label>
                                    <div class="ein-boxes">
                                        <span class="ein-group">{{ employer_identification_number ?
                                            employer_identification_number.substring(0, 2) : '__' }}</span>
                                        <span class="separator">-</span>
                                        <span class="ein-group">{{ employer_identification_number ?
                                            employer_identification_number.substring(2, 9) : '_______' }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Page Break for Page 2 -->
                <div class="html2pdf__page-break"></div>
                <div class="page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 2</div>
                    </div>
                    <!-- Part II: Certification -->
                    <div class="">
                        <div class="certification-content">
                            <div class="certification-content">
                                <!-- Part II: Certification -->
                                <div class="part-section" style="margin-bottom: 0;">
                                    <div class="part-header">
                                        <h2><span class="part-number">Part II</span> Certification</h2>
                                    </div>
                                </div>
                                <p>Under penalties of perjury, I certify that:</p>
                                <ol type="1">
                                    <li>The number shown on this form is my correct taxpayer identification number (or I
                                        am
                                        waiting for a number to be issued to me); and</li>
                                    <li>I am not subject to backup withholding because: (a) I am exempt from backup
                                        withholding, or (b) I have not been notified by the Internal Revenue Service
                                        (IRS)
                                        that I am subject to backup withholding as a result of a failure to report all
                                        interest or dividends, or (c) the IRS has notified me that I am no longer
                                        subject to
                                        backup withholding; and</li>
                                    <li>I am a U.S. citizen or other U.S. person (defined below); and</li>
                                    <li>The FATCA code(s) entered on this form (if any) indicating that I am exempt from
                                        FATCA reporting is correct.</li>
                                </ol>

                                <p><strong>Certification instructions.</strong> You must cross out item 2 above if you
                                    have
                                    been notified by the IRS that you are currently subject to backup withholding
                                    because
                                    you have failed to report all interest and dividends on your tax return. For real
                                    estate
                                    transactions, item 2 does not apply. For mortgage interest paid, acquisition or
                                    abandonment of secured property, cancellation of debt, contributions to an
                                    individual
                                    retirement arrangement (IRA), and generally, payments other than interest and
                                    dividends,
                                    you are not required to sign the certification, but you must provide your correct
                                    TIN.
                                    See the instructions for Part II, later.</p>
                            </div>
                        </div>

                        <!-- Signature Section -->
                        <div class="signature-section">
                            <div class="sign-here">
                                <h3>Sign<br>Here</h3>
                            </div>

                            <div class="signature-field">
                                <div class="signature-line">
                                    <label><strong>Signature of U.S. person</strong></label>
                                    <div class="signature-box">
                                        <img v-if="signature_of_us_person" :src="signature_of_us_person" alt="Signature"
                                            class="signature-image">
                                        <span v-else class="signature-placeholder">_________________________</span>
                                    </div>
                                </div>

                                <div class="date-field">
                                    <label><strong>Date</strong></label>
                                    <span class="date-value">{{ date || '_____________' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- General Instructions Section -->
                        <div class="instructions-page">
                            <div class="instructions-content">
                                <h2>General Instructions</h2>
                                <p>Section references are to the Internal Revenue Code unless otherwise noted.</p>

                                <p><strong>Future developments.</strong> For the latest information about developments
                                    related to Form W-9 and its instructions, such as legislation enacted after they
                                    were
                                    published, go to www.irs.gov/FormW9.</p>

                                <h3>Purpose of Form</h3>
                                <p>An individual or entity (Form W-9 requester) who is required to file an information
                                    return with the IRS must obtain your correct taxpayer identification number (TIN)
                                    which
                                    may be your social security number (SSN), individual taxpayer identification number
                                    (ITIN), adoption taxpayer identification number (ATIN), or employer identification
                                    number (EIN), to report on an information return the amount paid to you, or other
                                    amount
                                    reportable on an information return. Examples of information returns include, but
                                    are
                                    not limited to, the following:</p>

                                <ul type="disc">
                                    <li>Form 1099-INT (interest earned or paid)</li>
                                    <li>Form 1099-DIV (dividends, including those from stocks or mutual funds)</li>
                                    <li>Form 1099-MISC (various types of income, prizes, awards, or gross proceeds)</li>
                                    <li>Form 1099-B (stock or mutual fund sales and certain other transactions by
                                        brokers)
                                    </li>
                                    <li>Form 1099-S (proceeds from real estate transactions)</li>
                                    <li>Form 1099-K (merchant card and third party network transactions)</li>
                                    <li>Form 1098 (home mortgage interest), 1098-E (student loan interest), 1098-T
                                        (tuition)
                                    </li>
                                    <li>Form 1099-C (canceled debt)</li>
                                    <li>Form 1099-A (acquisition or abandonment of secured property)</li>
                                </ul>

                                <p class="indented">Use Form W-9 only if you are a U.S. person (including a resident
                                    alien), to provide your correct TIN.</p>

                                <p class="indented"><em>If you do not return Form W-9 to the requester with a TIN, you
                                        might be subject to backup withholding. See What is backup withholding,
                                        later.</em>
                                </p>

                                <p>By signing the filled-out form, you:</p>
                                <ol type="1">
                                    <li>Certify that the TIN you are giving is correct (or you are waiting for a number
                                        to
                                        be issued),</li>
                                    <li>Certify that you are not subject to backup withholding, or</li>
                                    <li>Claim exemption from backup withholding if you are a U.S. exempt payee. If
                                        applicable, you are also certifying that as a U.S. person, your allocable share
                                        of
                                        any partnership income from a U.S. trade or business is not subject to the
                                        withholding tax on foreign partners' share of effectively connected income, and
                                    </li>
                                    <li>Certify that FATCA code(s) entered on this form (if any) indicating that you are
                                        exempt from the FATCA reporting, is correct. See What is FATCA reporting? on
                                        page 2
                                        for further information.
                                    </li>
                                </ol>

                                <p><strong>Note:</strong> If you are a U.S. person and a requester gives you a form
                                    other
                                    than Form W-9 to request your TIN, you must use the requester's form if it is
                                    substantially
                                    similar to this Form W-9.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Page Break for Page 3 -->
                <div class="html2pdf__page-break"></div>
                <div class="page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 3</div>
                    </div>
                    <div class="two-column-list">
                        <p><strong>Definition of a U.S. person.</strong> For federal tax purposes, you are
                            considered a U.S. person if you are:</p>
                        <ul type="disc">
                            <li>An individual who is a U.S. citizen or U.S. resident alien;</li>
                            <li>A partnership, corporation, company, or association created or organized in the
                                United States or under the laws of the United States;</li>
                            <li>An estate (other than a foreign estate); or</li>
                            <li>A domestic trust (as defined in Regulations section 301.7701-7).</li>
                        </ul>

                        <p><strong>Special rules for partnerships.</strong> Partnerships that conduct a trade or
                            business in the United States are generally required to pay a withholding tax under
                            section 1446 on any foreign partners' share of effectively connected taxable income
                            from
                            such business. Further, in certain cases where a Form W-9 has not been received, the
                            rules under section 1446 require a partnership to presume that a partner is a
                            foreign
                            person, and pay the section 1446 withholding tax. Therefore, if you are a U.S.
                            person
                            that is a partner in a partnership conducting a trade or business in the United
                            States,
                            provide Form W-9 to the partnership to establish your U.S. status and avoid section
                            1446
                            withholding on your share of partnership income.</p>

                        <p>In the cases below, the following person must give Form W-9 to the partnership
                            for purposes of establishing its U.S. status and avoiding withholding on its
                            allocable share of net income from the partnership conducting a trade or business
                            in the United States:</p>

                        <ul type="disc">
                            <li>In the case of a disregarded entity with a U.S. owner, the U.S. owner of the
                                disregarded entity and not the entity;</li>
                            <li>In the case of a grantor trust with a U.S. grantor or other U.S. owner, generally,
                                the U.S. grantor or other U.S. owner of the grantor trust and not the trust; and
                            </li>
                            <li>In the case of a U.S. trust (other than a grantor trust), the U.S. trust (other than
                                a grantor trust) and not the beneficiaries of the trust.</li>
                        </ul>

                        <p><strong>Foreign person.</strong> If you are a foreign person or the U.S. branch of a
                            foreign bank
                            that has elected to be treated as a U.S. person, do not use Form W-9. Instead, use
                            the appropriate Form W-8 or Form 8233 (see Publication 515, Withholding of Tax
                            on Nonresident Aliens and Foreign Entities).</p>
                        <p><strong>Nonresident alien who becomes a resident alien.</strong> Generally, only a
                            nonresident
                            alien individual may use the terms of a tax treaty to reduce or eliminate U.S. tax on
                            certain types of income. However, most tax treaties contain a provision known as
                            a "saving clause." Exceptions specified in the saving clause may permit an
                            exemption from tax to continue for certain types of income even after the payee
                            has otherwise become a U.S. resident alien for tax purposes.</p>


                        <p>If you are a U.S, resident alien who is relying on an exception contained in the saving
                            clause of a tax treaty to claim an exemption from U.S. tax on certain types of income,
                            you must attach a statement to Form W-9 that specifies the following five items:</p>

                        <ol type="1">
                            <li>The treaty country. Generally, this t mustt be the same treaty under which you
                                claimed exemption from tax as a nonresident alien.</li>
                            <li>The treaty article addressing the income.</li>
                            <li>The article number (or location) in the tax treaty that contains the saving
                                clause and its exceptions.</li>
                            <li>The type and amount of income that qualifies for the exemption from tax.</li>
                            <li>Sufficient facts to justify the exemption from tax under the terms of the treaty
                                article.</li>
                        </ol>

                        <p>
                            <strong>Example. </strong> Article 20 of the U.S.-China income tax treaty allows an
                            exemption from tax for
                            scholarship income received by a Chinese student temporarily present in the United
                            States. Under U.S. law, this student will become a resident alien for tax purposes if
                            his or her stay in the United States exceeds 5 calendar years. However, paragraph 2 of
                            the first Protocol to the U.S.-China treaty (dated April 30, 1984) allows the provisions
                            of Article 20 to contin ntinue to apply even after the Chinese student becomes a
                            resident alien of the United States. A Chinese student who qualifies for this exception
                            (under paragraph 2 of the first protocol) and is relying on this exception to claim an
                            exemption from tax on his or her scholarship or fellowship income would attach to Form
                            W-9 a statement that includes the information described above to support that exemption.
                        </p>

                        <p>
                            If you are a nonresident alien or a foreign entity, give the requester the appropriate
                            completed Form W-8 or Form 8233.
                        </p>

                        <h2>Backup Withholding</h2>
                        <p><strong>What is backup withholding?</strong> Persons making certain payments to you must
                            under certain
                            conditions withhold and pay to the IRS 28% of such payments. This is called "backup
                            withholding." Payments that may be subject to backup withholding include interest,
                            tax-exempt interest, dividends, broker and barter exchange transactions, rents,
                            royalties, nonemployee pay, payments made in settlement of payment card and third party
                            network transactions, and certain payments from fishing boat operators. Real estate
                            transactions are not subject to backup withholding.</p>

                        <p>You will not be subject to backup withholding on payments you receive if you give the
                            requester your correct TIN, make the proper prope ccertifications, and report all your
                            taxable interest and dividends on your tax return.</p>

                        <p><strong>Payments you receive will be subject to backup withholding if:</strong></p>
                        <ol type="1">
                            <li>You do not furnish your TIN to the requester.</li>
                            <li>. You do not certify your TIN when required (see the Part II instructions on page 3
                                for details),</li>
                            <li>The IRS tells the requester that you furnished an incorrect TIN,</li>
                            <li>The IRS tells you that you are subject to backup withholding because you did not
                                report all your interest and dividends on your tax return (for reportable interest
                                and dividends only), or</li>
                            <li> You do not certify to the requester that you are not subject to backup withholding
                                under 4 above (for reportable interest and dividend accounts opened after 1983
                                only).</li>
                        </ol>

                    </div>
                </div>

                <!-- Page Break for Page 4 -->
                <div class="html2pdf__page-break"></div>
                <div class=" page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 4</div>
                    </div>
                    <div class="two-column-list">
                        <p>Certain payees and payments are exempt from backup withholding. See <em>Exempt
                                payee</em> code on page 3 and the separate Instructions for the Requester of Form
                            W-9 for more information.
                        </p>

                        <p>Also see <em>Special rules for partnerships </em> above.</p>

                        <h3>What is FATCA Reporting?</h3>
                        <p>The Foreign Account Tax Compliance Act (FATCA) requires a participating foreign
                            financial institution to report all United States account holders that are specified
                            United States persons. Certain payees are exempt from FATCA reporting. See
                            Exemption from FATCA reporting code on page 3 and the instructions for the
                            Requester of Form W-9 for more information.</p>


                        <h3>Updating Your Information</h3>
                        <p>You must provide updated information to any person to whom you claimed to be an
                            exempt payee if you are no longer an exempt payee and anticipate receiving
                            reportable payments in the future from this person. For example, you may need to
                            provide updated information if you are a C corporation that elects to be an S
                            corporation, or if you no longer are tax exempt. In addition, you must furnish a new
                            Form W-9 if the name or TIN changes for the account; for example, if the grantor
                            of a grantor trust dies.</p>

                        <h3>Penalties</h3>
                        <p><strong>Failure to furnish TIN.</strong> If you fail to furnish your correct TIN to a
                            requester, you are
                            subject to a penalty of $50 for each such failure unless your failure is due to
                            reasonable cause and not to willful neglect.</p>

                        <p><strong>Civil penalty for false information with respect to withholding.</strong> If you
                            make a
                            false statement with no reasonable basis that results in no backup withholding,
                            you are subject to a $500 penalty.</p>

                        <p><strong>Criminal penalty for falsifying information.</strong> Willfully falsifying
                            certifications or
                            affirmations may subject you to criminal penalties including fines and/or
                            imprisonment.</p>

                        <p><strong>Misuse of TINs.</strong> If the requester discloses or uses TINs in violation of
                            federal law,
                            the requester may be subject to civil and criminal penalties.</p>

                        <h2>Specific Instructions</h2>

                        <h3>Line 1</h3>
                        <p>You must enter one of the following on this line; do not leave this line blank. The
                            name should match the name on your tax return.</p>

                        <p>If this Form W-9 is for a joint account (other than an account maintained by a foreign
                            financial institution (FFI)), list first, and then circle, the name of the person or
                            entity whose number you entered in Part I of Form W-9. If you are providing Form W-9 to
                            an FFI to document a joint account, each holder of the account that is
                            a U.S. person must provide a Form W-9.</p>

                        <p class="indented"><strong>a. Individual.</strong> Generally, enter the name shown on your
                            tax return. If you have changed your last name without informing the Social Security
                            Administration (SSA) of the name change, enter your first name, the last name shown on
                            your social security card, and your new last name.</p>

                        <p class="indent-note">Example: You are a married woman who has not informed the SSA that
                            you changed
                            your last name. Enter: Mary Smith Brown (Brown is your new last name).</p>

                        <p class="indented"><strong>b. Sole proprietor or single-member LLC.</strong> Enter your
                            individual name as shown on your 1040/1040A/1040EZ on line 1. You may enter your
                            business, trade, or "doing business as" (DBA) name on line 2.</p>

                        <p class="indented"><strong>c. Partnership, LLC that is not a single-member LLC, C
                                Corporation, or S Corporation.</strong> Enter the entity's name as shown on the
                            entity's tax return on line 1 and any business, trade, or DBA name on line 2.</p>

                        <p class="indented"><strong>d. Other entities.</strong> Enter your name as shown on required
                            U.S. federal tax documents on line 1. This name should match the name shown on the
                            charter or other legal document creating the entity. You may enter any business, trade,
                            or DBA name on line 2.</p>

                        <p class="indented"><strong>e. Disregarded entity.</strong> For U.S. federal tax purposes,
                            an entity that is egarded as an entity separate from its owner is treated as a
                            "disregarded entity." See Regulations section 301.7701-2(c)(2) (ii). Enter the owner's
                            name on line 1. The name of the entity entered on line 1 should never be a disregarded
                            entity. The name on line 1 should be the name shown on the income tax return on which
                            the income should be reported. For example, if a foreign LLC that is treated as a
                            disregarded entity for U.S. federal tax purposes has a single owner that is a U.S.
                            person, the U.S. owner's name is required to be provided on line 1. If the direct owner
                            of the entity is also a disregarded entity, enter the first owner that is not
                            disregarded for federal tax purposes. Enter the disregarded entity's name on line 2,
                            "Business name/disregarded entity name."" IfIf the owner of the disregarded entity is a
                            foreign person, the owner must complete an appropriate Form W-8 Instead of a Form W-9.
                            This is the case even if the foreign person has a U.S. TIN.
                        </p>

                        <h3>Line 2</h3>
                        <p>If you have a business name, trade name, DBA name, or disregarded entity name, you
                            may enter it on line 2.</p>

                        <h3>Line 3</h3>
                        <p>Check the appropriate box on line 3 for the U.S. federal tax classification of the
                            person whose name is entered on line 1. Check only one box on line 3.</p>

                        <p><strong>Limited Liability Company (LLC).</strong> If the name on Ilne 1 is an LLC treated
                            as a partnership for U.S. federal tax purposes, check the "Limited Liability Company"
                            box and enter "P" in the space provided. If the LLC has filed Form 8832 or 2553 to be
                            taxed as a corporation, check the "Limited Liability Company" bo 'box and in the space
                            provided enter "C" for C corporation or "S" for S corporation. If it is a single-member
                            LLC that is a disregarded entity, do not v, do not check the "Limited Liability Company"
                            box; instead check the first box in line 3 "Individual/sole proprietor or single-member
                            LLC." </p>

                        <h3>Line 4, Exemptions</h3>
                        <p>If you are exempt from backup withholding and/or FATCA reporting, enter in the
                            appropriate space in line 4 any code(s) that may apply to you.</p>

                        <p><strong>Exempt payee code.</strong></p>

                        <ul type="disc">
                            <li>Generally, individuals (including sole proprietors) are not exempt from backup
                                withholding.</li>
                        </ul>

                    </div>
                </div>

                <!-- Page Break for Page 5 -->
                <div class="html2pdf__page-break"></div>
                <div class=" page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 5</div>
                    </div>
                    <div class="two-column-list">
                        <ul type="disc">
                            <li>Except as provided below, corporations are exempt from backup withholding for
                                certain payments, including interest and dividends.</li>
                            <li>Corporations are not exempt from backup withholding for payments made in
                                settlement of payment card or third party network transactions.</li>
                            <li> Corporations are not exempt from backup withholding with respect to attorneys fees
                                or gross proceeds paid to attorneys, and corporations that provide medical or health
                                care services are not exempt with respect to payments reportable on Form 1099-MISC.
                            </li>
                        </ul>

                        <p>The following codes identify payees that are exempt from backup withholding. Enter
                            the appropriate code in the space in line 4.</p>

                        <p>1—An organization exempt from tax under section 501(a), any IRA, or a custodial
                            account under section 403(b)(7) if the account satisfies the requirements of
                            section 401(f)(2)</p>

                        <p>2—The United States or any of its agencies or instrumentalities</p>

                        <p>3—A state, the District of Columbia, a U.S. commonwealth or possession, or any of
                            their subdivisions or instrumentalities</p>

                        <p>4—A foreign government or any of its subdivisions, agencies, or instrumentalities</p>

                        <p>5—A corporation</p>

                        <p>6—A dealer in securities or commodities required to register in the United States,
                            the District of Columbia, or a U.S. commonwealth or possession</p>

                        <p>7—A futures commission merchant registered with the Commodity Futures Trading
                            Commission</p>

                        <p>8—A real estate investment trust</p>

                        <p>9—An entity registered at all times during the tax year under the Investment
                            Company Act of 1940</p>

                        <p>10—A common trust fund operated by a bank under section 584(a)</p>

                        <p>11—A financial institution</p>

                        <p>12—A middleman known in the investment community as a nominee or custodian</p>

                        <p>13—A trust exempt from tax under section 664 or described in section 4947</p>

                        <p>The following chart shows types of payments that may be exempt from backup withholding.
                            The chart applies to the exempt payees listed above, 1 through 13.</p>

                        <table border="1" cellpadding="5" style="margin-bottom: 8px">
                            <thead>
                                <tr>
                                    <th>IF the payment is for...</th>
                                    <th>IF the payment is for...</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Interest and dividend payments</td>
                                    <td>All exempt payees except for 7</td>
                                </tr>
                                <tr>
                                    <td>Broker transactions</td>
                                    <td>Exempt payees 1 through 4 and 6 through 11 and all C corporations. S
                                        corporations must not enter an exempt payee code because they are exempt
                                        only for sales of noncovered securities acquired prior to 2012.</td>
                                </tr>
                                <tr>
                                    <td>Barter exchange transactions and patronage dividends</td>
                                    <td>Exempt payees 1 through 4</td>
                                </tr>
                                <tr>
                                    <td>Payments over $600 required to be reported and direct sales over
                                        $5,000<sup>1</sup></td>
                                    <td>Generally, exempt payees 1 through 5<sup>2</sup></td>
                                </tr>
                                <tr>
                                    <td>Payments made in settlement of payment card or third party network
                                        transactions</td>
                                    <td>Exempt payees 1 through 4</td>
                                </tr>
                            </tbody>
                        </table>

                        <p><sup>1</sup> See Form 1099-MISC, Miscellaneous Income, and its instructions.</p>

                        <p><sup>2</sup>However, the following payments made to a corporation and reportable on Form
                            1099-MISC are not exempt from backup withholding: medical and health care payments,
                            attorneys' fees, gross proceeds paid to an attorney reportable under section 6045(f),
                            and payments for services paid by a federal executive agency.</p>

                        <p><strong>Exemption from FATCA reporting code.</strong> The following codes identify payees
                            that are
                            exempt from reporting under FATCA. These codes apply to persons submitting this form
                            for accounts maintained outside of the United States by certain foreign financial
                            institutions. Therefore, if you are only submitting this form for an account you hold
                            in the United States, you may leave this field blank. Consult with the person
                            requesting this form if you are uncertain if the financial institution is subject to
                            these requirements. A requester may indicate that a code is not required by providing
                            you with a Form W-9 with "Not Applicable" (or any similar indication) written or
                            printed on the line for a FATCA exemption code.</p>

                        <p>A—An organization exempt from tax under section 501(a) or any individual retirement
                            plan as defined in section 7701(a)(37)</p>

                        <p>B—The United States or any of its agencies or instrumentalities</p>

                        <p>C—A state, the District of Columbia, a U.S. commonwealth or possession, or any of
                            their subdivisions or instrumentalities</p>

                        <p>D—A corporation the stock of which is regularly traded on one or more established
                            securities markets, as described in Reg. section 1.1472-1(c)(1)(i)</p>

                        <p>E—A corporation that is a member of the same expanded affiliated group as a
                            corporation described in Reg. section 1.1472-1(c)(1)(i)</p>

                        <p>F—A dealer in securities, commodities, or derivative financial instruments
                            (including notional principal contracts, futures, forwards, and options) that is
                            registered as such under the laws of the United States or any state</p>

                        <p>G—A real estate investment trust</p>

                        <p>H—A regulated investment company as defined in section 851 or an entity registered
                            at all times during the tax year under the Investment Company Act of 1940</p>

                        <p>I—A common trust fund as defined in section 584(a)</p>

                        <p>J—A bank as defined in section 581</p>

                        <p>K—A broker</p>

                        <p>L—A trust exempt from tax under section 664 or described in section 4947(a)(1)</p>

                        <p>M—A tax exempt trust under a section 403(b) plan or section 457(g) plan</p>


                    </div>
                </div>
                <!-- Page Break for Page 5 -->
                <div class="html2pdf__page-break"></div>
                <div class=" page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 6</div>
                    </div>
                    <div class="two-column-list">
                        <p><strong>Note.</strong> You may wish to consult with the financial institution requesting
                            this form to determine whether the FATCA code and/or exempt payee code should be
                            completed.
                        </p>

                        <h3>Line 5</h3>
                        <p>Enter your address (number, street, and apartment or suite number). This is where the
                            requester of this form will mail your information returns. If this address differs
                            from the one the requester already has on file, write "NEW" at the top. If a new
                            address is provided, there is still a possibility the old address will be used until
                            the payor changes your address in their records.</p>

                        <h3>Line 6</h3>
                        <p>Enter your city, state, and ZIP code.</p>

                        <h3>Part I. Taxpayer Identification Number (TIN)</h3>
                        <p><strong>Enter your TIN in the appropriate box.</strong> If you are a resident alien and
                            you do not have
                            and are not eligible to get an SSN, your TIN is your IRS individual taxpayer
                            identification number (ITIN). Enter it in the social security number box. If you do not
                            have an ITIN, see How to get a TIN below.</p>

                        <p>If you are a sole proprietor and you have an EIN, you may enter either your SSN or EIN.
                        </p>

                        <p>If you area single-member LLC that is disregarded as an entity separate from its
                            owner (see Limited Liability Company (LLC) on this page), enter the owner's SSN
                            (or EIN, if the owner has one). Do not enter the disregarded entity's EIN. If the LLC
                            is classified as a corporation or partnership, enter the entity's EIN.
                        </p>

                        <p><strong>Note:</strong> See the chart on page 4 for further clarification of name and TIN
                            combinations.</p>

                        <p><strong>How to get a TIN.</strong>If you do not have a TIN, apply for one immediately. To
                            apply for an SSN, get Form SS-5, Application for a Social Security Card, from your local
                            SSA office or get this form online at www.ssa.gov. You may also get this form by calling
                            1-800-772-1213. Use Form W-7, Application for IRS Individual Taxpayer Identification
                            Number, to apply for an ITIN, or Form SS-4, Application for Employer Identification
                            Number, to apply for an EIN. You can apply for an EIN online by accessing the IRS
                            website at www.irs.gov/businesses and clicking on Employer Identification Number (EIN)
                            under Starting a Business. You can getro get Forms W-7 and SS-4 from the IRS by visiting
                            IRS.gov or by calling 1-800-TAX-FORM (1-800-829-3676).</p>

                        <p>If you are asked to complete Form W-9 but do not have a TIN, apply for a TIN and
                            write "Applied For" in the space for the TIN, sign and date the form, and give it to the
                            requester. For interest and dividend payments, and certain payments made with respect to
                            readily tradable instruments, generally you will have 60 days to get a TIN and give it
                            to the requester before you are subject to backup withholding on payments. The 60-day
                            rule does not apply to other types of payments. You will be subject to backup
                            withholding
                            on all such payments until you provide your TIN to the requester.</p>

                        <p><strong>Note:</strong> Entering "Applied For" means that you have already applied for a
                            TIN or that you intend to apply for one soon.</p>

                        <p><em>Caution: A disregarded U.S. entity that has a foreign owner must use the appropriate
                                Form W-8.</em></p>

                        <h3>Part II. Certification</h3>
                        <p>To establish to the withholding agent that you are a U.S. person, or resident alien, sign
                            Form W-9. You may be requestedd to sign by the withholding agent even if items 1, 4, or
                            5 below indicate otherwise.</p>

                        <p>For a joint account, only the person whose TIN is shown in Part I should sign (when
                            required). In the case of a disregarded entity, the person identified on line 1 must
                            sign. Exempt payees, see Exempt payee code earlier.</p>

                        <p><strong>Signature requirements.</strong> Complete the certification as indicated in items
                            1 through 5 below.</p>

                        <ol type="1">
                            <li>
                                <strong>Interest, dividend, and barter exchange accounts opened before 1984 and
                                    broker accounts considered active during 1983.</strong> You must give your
                                correct TIN, but you do not have to sign the certification.
                            </li>
                            <li>
                                <strong>Interest, dividend, broker, and barter exchange accounts opened after 1983
                                    and broker accounts considered inactive during 1983.</strong> You must sign the
                                certification or backup withholding will apply. If you are subject to backup
                                withholding and you are merely providing your correct TIN to the requester,
                                you must cross out item 2 in the certification before signing the form.
                            </li>
                            <li>
                                <strong>Real estatetransactions.</strong> You must sign the certification. You may
                                cross out item 2
                                of the certification.
                            </li>
                            <li>
                                <strong>Other payments.</strong> You must give your correct TIN, but you do not have
                                to sign the certification unless you have been notified that you have previously
                                given an incorrect TIN. "Other payments" include payments made in the course of the
                                requester's trade or business for rents, royalties, goods (other than bills for
                                merchandise), medical and health care services (including payments to corporations),
                                payments to a nonemployee for services, payments made in settlement of payment card
                                and third party network transactions, payments to certain fishing boat crew members
                                and fishermen, and gross proceeds paid to attorneys (including payments to
                                corporations).
                            </li>
                            <li><strong>Mortgage interest paid by you, acquisition or abandonment of secured
                                    property, cancellation of debt, qualified tuition program payments (under
                                    section 529), IRA, Coverdell ESA, Archer MSAHSco MSA or HSA contributions or
                                    distributions, and pension distributions.</strong> You must give your correct
                                TIN, but you do not have to sign the certification.
                            </li>
                        </ol>

                        <h2>What Name and Number To Give the Requester</h2>
                        <table border="1" cellpadding="5">
                            <thead>
                                <tr>
                                    <th>For this type of account:</th>
                                    <th>Give name and SSN of:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>1. Individual</td>
                                    <td>The individual</td>
                                </tr>
                                <tr>
                                    <td>2. Two or more individuals (joint account)</td>
                                    <td>The actual owner of the account or, if combined funds, the first individual
                                        on the account<sup>1</sup></td>
                                </tr>
                                <tr>
                                    <td>3. Custodian account of a minor (Uniform Gift to Minors Act)</td>
                                    <td>The minor<sup>2</sup></td>
                                </tr>
                                <tr>
                                    <td>4. a. The usual revocable savings trust (grantor is also trustee)<br />b.
                                        So-called trust account that is not a legal or valid trust under state law
                                    </td>
                                    <td>The grantor-trustee<sup>1</sup>
                                        <br>
                                        The actual owner <sup>1</sup>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- Page Break for Page 7 -->
                <div class="html2pdf__page-break"></div>
                <div class=" page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 7</div>
                    </div>
                    <div class="two-column-list">

                        <table border="1" cellpadding="5">
                            <thead>
                                <tr>
                                    <th>For this type of account:</th>
                                    <th>Give name and SSN of:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>5. Sole proprietorship or disregarded entity owned by an individual</td>
                                    <td>The owner<sup>3</sup></td>
                                </tr>
                                <tr>
                                    <td>6. Grantor trust filing under Optional Form 1099 Filing Method 1 (see
                                        Regulations section 1.671-4(b)(2)(i)(A))</td>
                                    <td>The grantor<sup>*</sup></td>
                                </tr>
                            </tbody>
                        </table>
                        <table border="1" cellpadding="5" style="margin-bottom: 8px">
                            <thead>
                                <tr>
                                    <th>For this type of account:</th>
                                    <th>Give name and EIN of:</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>7. Disregarded entity not owned by an individual</td>
                                    <td>The owner</td>
                                </tr>
                                <tr>
                                    <td>8. A valid trust, estate, or pension trust</td>
                                    <td>Legal entity<sup>4</sup></td>
                                </tr>
                                <tr>
                                    <td>9. Corporation or LLC electing corporate status on Form 8832 or Form 2553
                                    </td>
                                    <td>The corporation</td>
                                </tr>
                                <tr>
                                    <td>10. Association, club, religious, charitable, educational, or other
                                        tax-exempt organization</td>
                                    <td>The organization</td>
                                </tr>
                                <tr>
                                    <td>11. Partnership or multi-member LLC</td>
                                    <td>The partnership</td>
                                </tr>
                                <tr>
                                    <td>12. A broker or registered nominee</td>
                                    <td>The broker or nominee</td>
                                </tr>
                                <tr>
                                    <td>13. Account with the Department of Agriculture in the name of a public
                                        entity (such as a state or local government, school district, or prison)
                                        that receives agricultural program payments</td>
                                    <td>The public entity</td>
                                </tr>
                                <tr>
                                    <td>14. Grantor trust filing under the Form 1041 Filing Method or the Optional
                                        Form 1099 Filing Method 2 (see Regulations section 1.671-4(b)(2)(i)(B))</td>
                                    <td>The trust</td>
                                </tr>
                            </tbody>
                        </table>

                        <p><sup>1</sup> List first and circle the name of the person whose number you furnish. If
                            only one person on a joint account has an SSN, that person's number must be furnished.
                        </p>
                        <p><sup>2</sup> Circle the minor's name and furnish the minor's SSN.</p>
                        <p><sup>3</sup> You must show your individual name and you may also enter your business or
                            DBA name on
                            the "Business name/disregarded entity" name line. You may use either your SSN or EIN (if
                            you
                            have one), but the IRS encourages you to use your SSN.</p>
                        <p><sup>4</sup> List first and circle the name of the trust, estate, or pension trust. (Do
                            not furnish the TIN of the
                            personal representative or trustee unless the legal entity itself is not designated in
                            the account
                            title.) Also see <em>Special rules for partnerships</em> on page 2.</p>
                        <p><sup>*</sup> Note: The grantor also must provide a Form W-9 to trustee of trust.</p>

                        <p><strong>Note:</strong> If no name is circled when more than one name is listed, the
                            number will be
                            considered to be that of the first name listed.</p>

                        <h2>Secure Your Tax Records from Identity Theft</h2>
                        <p>Identity theft occurs when someone uses your personal information such as your
                            name, SSN, or other identifying information, without your permission, to commit
                            fraud or other crimes. An identity thief may use your SSN to get a job or may file a
                            tax return using your SSN to receive a refund.</p>

                        <p><strong>To reduce your risk:</strong></p>
                        <ul>
                            <li>Protect your SSN,</li>
                            <li>Ensure your employer is protecting your SSN, and</li>
                            <li>Be careful when choosing a tax preparer.</li>
                        </ul>

                        <p>If your tax records are affected by identity theft and you receive a notice from
                            the IRS, respond right away to the name and phone number printed on the IRS
                            notice or letter.</p>

                        <p>If your tax records are not currently affected by identity theft but you think you
                            are at risk due to a lost or stolen purse or wallet, questionable credit card activity
                            or credit report, contact the IRS Identity Theft Hotline at 1-800-908-4490 or submit
                            Form 14039.</p>

                        <p>For more information, see Publication 4535, Identity Theft Prevention and Victim
                            Assistance.</p>

                        <p><strong>Victims of identity theft who are experiencing economic harm or a system
                                problem, or are seeking help in resolving tax problems that have not been resolved
                                through normal channels, may be eligible for Taxpayer Advocate Service (TAS)
                                assistance.</strong> You can reach TAS by calling the TAS toll-free case intake line
                            at 1-877-777-4778 or TTY/TDD 1-800-829-4059.</p>

                        <p><strong>Protect yourself from suspicious emails or phishing schemes.</strong></p>
                        <p>Phishing is the creation and use of email and websites designed to mimic legitimate
                            business
                            emails and websites. The most common act is sending an email to a user falsely
                            claiming to be an established legitimate enterprise in an attempt to scam the user
                            into surrendering private information that will be used for identity theft.</p>
                        <p>The IRS does not initiate contacts with taxpayers via emails. Also, the IRS does
                            not request personal detailed information through email or ask taxpayers for the
                            PIN numbers, passwords, or similar secret access information for their credit card,
                            bank, or other financial accounts.</p>

                        <p>If you receive an unsolicited email claiming to be from the IRS, forward this
                            message to phishing@irs.gov. You may also report misuse of the IRS name, logo,
                            or other IRS property to the Treasury Inspector General for Tax Administration
                            (TIGTA) at 1-800-366-4484. You can forward suspicious emails to the Federal
                            Trade Commission at: spam@uce.gov or report them at www.ftc.gov/complaint or
                            1-877-IDTHEFT (1-877-438-4338).</p>

                        <p>Visit IRS.gov to learn more about identity theft and how to reduce your risk.</p>

                        <hr style="border: 2px solid #000; margin: 20px 0;">
                    </div>
                </div>

                <div class="html2pdf__page-break"></div>

                <div class="page-section">
                    <div class="page-header">
                        <div class="form-reference">Form W-9 (Rev. 12-2014)</div>
                        <div class="page-number">Page 8</div>
                    </div>
                    <div class="two-column-list last-page">
                        <h2>Privacy Act Notice</h2>
                        <p style="padding-bottom: 25px;">Section 6109 of the Internal Revenue Code requires you to
                            provide your correct
                            TIN to persons (including federal agencies) who are required to file information
                            returns with the IRS to report interest, dividends, or certain other income paid to
                            you; mortgage interest you paid; the acquisition or abandonment of secured
                            property; the cancellation of debt; or contributions you made to an IRA, Archer
                            MSA, or HSA. The person collecting this form uses the information on the form to
                            file information returns with the IRS, reporting the above information. Routine uses
                            of this information include giving it to the Department of Justice for civil and
                            criminal litigation and to cities, states, the District of Columbia, and U.S.
                            commonwealths and possessions for use in administering their laws. The
                            information also may be disclosed to other countries under a treaty, to federal and
                            state agencies to enforce civil and criminal laws, or to federal law enforcement and
                            intelligence agencies to combat terrorism. You must provide your TIN whether or
                            not you are required to file a tax return. Under section 3406, payers must generally
                            withhold a percentage of taxable interest, dividend, and certain other payments to
                            a payee who does not give a TIN to the payer. Certain penalties may also apply for
                            providing false or fraudulent information.</p>
                    </div>
                </div>

            </section>
        </vue-html2pdf>
    </div>
</template>

<script>
import axios from 'axios';
import VueHtml2pdf from 'vue-html2pdf';

export default {
    name: "W9ContractTemplate",
    components: { VueHtml2pdf },
    data() {
        return {
            tempId: '',
            type: '',
            tax_id: '',
            agentid: '',
            name: '',
            business_name: '',
            federal_tax: '',
            exempt_payee_code: '',
            exempt_fatca_reporting: '',
            list_account_numbers: '',
            street_address1: '',
            street_address2: '',
            city: '',
            state: '',
            zip: '',
            requester_name_address: '',
            social_security: '',
            employer_identification_number: '',
            pay_to: '',
            signature_of_us_person: '',
            date: '',
            is_complete: '',
            completed_upto: '',
            screenshot: '',
            items: [],
            comItems: [],
            level: '2',
            isGenerating: false,
            htmlToPdfOptions: {
                margin: [10, 10, 10, 10], // top, right, bottom, left margins in mm
                filename: '',
                enableLinks: true,
                image: {
                    type: 'jpeg',
                    quality: 1.0,
                },
                html2canvas: {
                    scale: 2,
                    scrollX: 0,
                    scrollY: 0,
                    useCORS: true,
                    logging: true,
                    letterRendering: true,
                },
                jsPDF: {
                    unit: 'mm',
                    format: 'a4',
                    orientation: 'portrait',
                    compress: true
                },
                pagebreak: {
                    mode: ["css", "legacy"], // respects page-break CSS
                    after: [".html2pdf__page-break"], // force new page before these elements
                    before: [], // force new page before these elements
                    avoid: [".page-section"]  // prevent breaking inside selectors
                }
            },
        };
    },
    mounted() {
        let app = this;
        app.tempId = app.$route.params.id;
        app.getContractData();
    },
    computed: {
        fullAddress() {
            if (this.city && this.state && this.zip) {
                return `${this.city}, ${this.state} ${this.zip}`;
            }
            return '';
        }
    },
    methods: {
        async beforeDownload({ html2pdf, options, pdfContent }) {
            var tempId = this.tempId;
            var agentId = this.agentid;
            html2pdf().set(options).from(pdfContent).toPdf().output('datauristring').then(function (pdfAsString) {
                
                let data = new FormData();
                data.append('pdf', pdfAsString);
                data.append('id', tempId);
                data.append('agent_id', agentId);
                data.append('type', 'w9');
                data.append('level', '0');

                axios.post(process.env.VUE_APP_CORENROLL_SYSTEM + '/save-contract-pdf', data)
                    .then(function (response) {
                        if (response.data.status == 'success') {
                            console.log("success");
                        }
                        window.location = '/contract-form/contract_message/success';
                    })
                    .catch(function (error) {
                        console.log(error.response.data.data);
                        if (error.response.data.status == 'error') {
                            error.response.data.data.forEach(function (item) {

                            });
                        }
                    });
            });
        },

        hasDownloaded(blob) {
            this.isGenerating = false;
        },

        generate() {
            this.isGenerating = true;
            this.htmlToPdfOptions.filename = `w9-form.pdf`;
            this.$refs.html2Pdf.generatePdf();
        },

        getContractData() {
            let app = this;
            axios.get(process.env.VUE_APP_CORENROLL_SYSTEM + '/get-contract-data-w9?', {
                params: {
                    tempid: [app.tempId],
                }
            })
                .then(function (response) {
                    const result = response.data.data.result;

                    // Define fields that should be updated from API
                    const fieldsToUpdate = [
                        'tax_id', 'agentid', 'name', 'business_name', 'federal_tax',
                        'exempt_payee_code', 'exempt_fatca_reporting', 'list_account_numbers',
                        'street_address1', 'street_address2', 'city', 'state', 'zip',
                        'requester_name_address', 'social_security', 'employer_identification_number',
                        'pay_to', 'signature_of_us_person', 'date', 'is_complete',
                        'completed_upto', 'screenshot'
                    ];

                    // Update only non-empty values using a clean approach
                    fieldsToUpdate.forEach(field => {
                        const value = result[field];
                        if (value !== null && value !== undefined && value !== '') {
                            app[field] = value;
                        }
                    });

                    app.generate();
                })
                .catch(function (error) {
                    console.log(error);
                    console.log('failed to generate pdf');
                });
        },

    }
};
</script>

<style scoped>
.content-wrapper {
    width: 100% !important;
}

/* W-9 Contract Template Styles */
.w9-contract-template {
    font-family: Arial, Helvetica, sans-serif;
    line-height: 1.3;
    width: 100%;
    margin: 0;
    padding: 0;
    padding: 0.1in 0.1in;
}

.page-content {
    width: 100%;
    margin: 0 auto;
    background: white;
    box-sizing: border-box;
}

.w9-contract-template *,
ol,
ul,
table * {
    font-size: 11px !important;
}

/* Header Styles */
.form-header {
    display: flex;
    border-bottom: 2px solid black;
    align-items: end;
}

.header-left {
    width: 22%;
    border-right: 2px solid black;
    padding-right: 10px;
}

.form-info p {
    margin: 1px 0;
    font-size: 12px;
    line-height: 1.1;
}

.form-w9 {
    font-size: 36px !important;
    font-weight: bold;
}

.header-center {
    width: 56%;
    text-align: center;
    padding: 0 15px;
}

.main-title {
    font-size: 16px !important;
    font-weight: bold;
    margin: 5px 0 12px 0;
    line-height: 1.1;
}

.header-right {
    width: 22%;
    height: -webkit-fill-available;
    height: -moz-available;
    border-left: 2px solid black;
    padding-left: 10px;
    display: flex;
    align-items: self-end;
    justify-content: flex-start;
    padding-bottom: 10px;
}

.give-form-text {
    font-size: 14px !important;
    font-weight: bold;
    text-align: left;
}

/* Form Body Styles */
.form-body {
    border-bottom: 2px solid black;
    position: relative;
    display: flex;
    align-items: flex-start;
}

.print-instruction-left {
    position: relative;
    width: 50px;
    height: 400px;
    border-right: 2px solid black;
    height: -webkit-fill-available;
}

.print-instruction {
    position: absolute;
    width: 200px;
    height: 50px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);
    transform-origin: center;
    text-align: center;
    display: flex;
    align-items: end;
    justify-content: center;
    padding-bottom: 10px;
}

.print-instruction p {
    margin: 0;
    line-height: 1.2;
    font-size: 12px;
    white-space: nowrap;
}

/* Form Lines */
.form-line {
    display: flex;
    margin-bottom: 12px;
    align-items: flex-start;
}

.line-number {
    width: 15px;
    font-weight: bold;
    margin-right: 8px;
    font-size: 11px;
    flex-shrink: 0;
}

.line-content {
    flex: 1;
}

.line-label {
    display: block;
    margin-bottom: 3px;
    font-size: 11px;
    line-height: 1.2;
}

.input-field {
    border-bottom: 1px solid black;
    min-height: 18px;
    padding: 2px 0;
}

.form-data {
    font-size: 12px;
}

/* Tax Classification Styles */
.tax-classification {
    align-items: flex-start;
}

.tax-options {
    display: flex;
    margin-top: 8px;
    gap: 20px;
}

.tax-options-left {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 7px
}

.tax-options-right {
    flex: 0 0 400px;
}

.checkbox-item {
    display: flex;
    align-items: flex-start;
    margin-bottom: 6px;
    font-size: 11px;
}

.radio-input {
    width: 12px;
    height: 12px;
    margin-right: 5px;
    margin-top: 2px;
    flex-shrink: 0;
    accent-color: black;
}

.checkbox {
    width: 12px;
    height: 12px;
    border: 1px solid black;
    margin-right: 5px;
    text-align: center;
    line-height: 10px;
    font-size: 12px;
    flex-shrink: 0;
}

/* Exemptions Box */
.exemptions-box {
    border: 1px solid black;
    padding: 8px;
    font-size: 11px;
}

.exemption-title {
    margin-bottom: 8px;
    line-height: 1.2;
}

.exemption-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.exemption-row label {
    flex: 1;
    font-size: 9px;
    line-height: 1.1;
}

.exemption-input {
    width: 100px;
    height: 15px;
    border: 1px solid black;
    margin-left: 5px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 3px;
}

.small-note {
    font-size: 7px;
    text-align: center;
    margin-top: 5px;
}

/* LLC Section */
.llc-section {
    margin-top: 12px;
}

.tax-class-input {
    border-bottom: 1px solid black;
    min-width: 50px;
    margin-left: 8px;
    padding: 0 5px;
    font-size: 11px;
}

.other-input {
    border-bottom: 1px solid black;
    min-width: 100px;
    margin-left: 8px;
    padding: 0 5px;
    font-size: 11px;
}

.llc-note {
    margin: 8px 0;
    font-size: 9px;
    line-height: 1.2;
    padding-left: 17px;
}

.other-item {
    margin-top: 8px;
}

/* Address Section */
.address-section {
    display: flex;
    gap: 15px;
    margin-top: 15px;
}

.address-left {
    flex: 2;
}

.requester-section {
    flex: 0 0 180px;
    border: 1px solid black;
    padding: 8px;
    height: fit-content;
}

.requester-label {
    font-size: 9px;
    display: block;
    margin-bottom: 8px;
    text-align: center;
}

.requester-box {
    min-height: 80px;
    font-size: 11px;
}

/* Part Sections */
.part-section {
    margin: 15px 0;
}

.part-header {
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    padding: 4px 0;
}

.part-header h2 {
    margin: 0;
    font-size: 14px !important;
}

.part-number {
    background: black;
    color: white;
    padding: 2px 6px;
    margin-right: 8px;
}

/* TIN Content */
.tin-content {
    display: flex;
    padding: 12px 0;
    gap: 20px;
}

.tin-instructions {
    flex: 2;
    font-size: 11px;
}

.tin-instructions p {
    margin-bottom: 8px;
    line-height: 1.3;
}

.tin-inputs {
    flex: 1;
    text-align: center;
}

.tin-field {
    margin-bottom: 12px;
}

.tin-field label {
    display: block;
    margin-bottom: 4px;
    font-size: 11px;
    font-weight: bold;
}

.ssn-boxes,
.ein-boxes {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
}

.ssn-group,
.ein-group {
    border: 1px solid black;
    padding: 3px 5px;
    text-align: center;
    font-family: monospace;
    font-size: 12px;
    min-width: 25px;
}

.separator {
    font-weight: bold;
    font-size: 12px;
}

.or-divider {
    text-align: center;
    margin: 12px 0;
    font-size: 12px;
    font-weight: bold;
}

/* Certification Content */
.certification-content {
    padding: 0;
}

.certification-content p {
    margin-bottom: 8px;
    /* line-height: 1.3; */
}

.certification-content ol,
.two-column-list ol {
    margin: 8px 0;
    padding-left: 20px;
    list-style-type: decimal;
    list-style-position: outside;
    display: block;
    font-size: 11px;
}

.certification-content li {
    margin-bottom: 6px;
    line-height: 1.3;
    display: list-item;
    list-style: inherit;
}

/* Signature Section */
.signature-section {
    display: flex;
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    margin-top: 15px;
}

.sign-here {
    width: 80px;
    border-right: 2px solid black;
    padding: 15px 8px;
    text-align: center;
}

.sign-here h3 {
    margin: 0;
    font-size: 12px;
    line-height: 1.2;
    font-weight: bold;
}

.signature-field {
    flex: 1;
    padding: 12px;
    display: flex;
}

.signature-line {
    flex: 2;
    margin-right: 15px;
}

.signature-line label {
    display: block;
    margin-bottom: 8px;
    font-size: 11px;
    font-weight: bold;
}

.signature-box {
    border-bottom: 1px solid black;
    min-height: 35px;
    position: relative;
}

.signature-image {
    max-width: 180px;
    max-height: 35px;
}

.date-field {
    flex: 1;
    text-align: right;
}

.date-field label {
    display: block;
    margin-bottom: 8px;
    font-size: 11px;
    font-weight: bold;
}

.date-value {
    border-bottom: 1px solid black;
    padding: 8px 0;
    min-width: 80px;
    display: inline-block;
    font-size: 12px;
}

/* Print Styles */
@media print {
    .page-content {
        width: 100%;
        margin: 0;
        padding: 0.3in;
    }
}

/* Instructions Page Styles */
.instructions-page {
    margin-top: 20px;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    border-bottom: 2px solid #000;
    padding: 5px 8px;
    margin-bottom: 15px;
    font-size: 12px;
    font-weight: normal;
}

.page-header .form-reference {
    font-weight: normal;
    color: #000;
}

.page-header .page-number {
    font-weight: bold;
    color: #000;
}

.form-reference {
    font-size: 12px;
}

.page-number {
    font-size: 14px;
    font-weight: bold;
}

.instructions-content {
    font-size: 11px;
    line-height: 1.3;
    column-count: 2;
    -moz-column-count: 2;
}

.instructions-content h2,
.two-column-list h2 {
    font-size: 16px !important;
    margin: 0 0 10px 0;
    font-weight: bold;
}

.instructions-content h3,
.two-column-list h3 {
    font-size: 14px !important;
    margin: 15px 0 8px 0;
    font-weight: 700;
}

.instructions-content p {
    margin-bottom: 10px;
    line-height: 1.3;
}

.instructions-content ul,
.two-column-list ul {
    margin: 10px 0 !important;
    padding-left: 20px !important;
    list-style-type: disc !important;
    list-style-position: outside !important;
    display: block !important;
}

.instructions-content ol {
    margin: 10px 0 !important;
    padding-left: 20px !important;
    list-style-type: decimal !important;
    list-style-position: outside !important;
    display: block !important;
}

.instructions-content li,
.two-column-list li {
    margin-bottom: 5px !important;
    line-height: 1.3 !important;
    display: list-item !important;
    list-style: inherit !important;
}

/* Specific list types */
.instructions-content ol[type="1"] {
    list-style-type: decimal !important;
}

.instructions-content ul[type="disc"] {
    list-style-type: disc !important;
}

/* Override any global resets that might interfere with lists */
.instructions-content ul::before,
.instructions-content ol::before,
.instructions-content li::before {
    content: none !important;
}

/* Ensure proper list item markers */
.instructions-content ul li {
    list-style-type: disc !important;
    list-style-position: outside !important;
}

.instructions-content ol li {
    list-style-type: decimal !important;
    list-style-position: outside !important;
}

/* Additional specificity for nested elements */
.two-column-list .column ul li {
    list-style-type: disc !important;
    list-style-position: outside !important;
    display: list-item !important;
}

.two-column-list .column ol li {
    list-style-type: decimal !important;
    list-style-position: outside !important;
    display: list-item !important;
}

.indented {
    text-indent: 5px;
}

.cat-no {
    position: absolute;
    bottom: 20px;
    left: 20px;
    font-size: 9px;
}

.form-designation {
    position: absolute;
    bottom: 20px;
    right: 20px;
    font-size: 9px;
}

/* Page break for PDF generation */
.html2pdf__page-break {
    page-break-after: always;
    break-after: page;
    height: 0;
    margin: 0;
    padding: 0;
    border: none;
    overflow: hidden;
    line-height: 0;
    font-size: 0;
}

.page-section {
    padding: 10px;
    display: block;
    margin-top: 0;
}

/* Two-column layout for exemption codes */
.two-column-list {
    column-count: 2;
    -moz-column-count: 2;
}

.two-column-list p {
    margin-bottom: 9px;
    font-size: 11px;
    line-height: 1.4;
}

/* Indented paragraphs */
.indented {
    margin-left: 5px;
}

.indent-note {
    margin-left: 10px;
    font-style: italic;
}

/* Table styling for equal columns */
.page-section table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.page-section table th,
.page-section table td {
    width: 50%;
    text-align: left;
    vertical-align: top;
    padding: 8px;
    border: 1px solid #000;
    font-size: 11px;
    line-height: 1.4;
}

.last-page{ 
    column-fill: auto;
}
</style>
